export default __webpack_public_path__ + "static/media/background-cover-image.d8bdaf9f.jpg";